import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      border: '1px solid #D2D2D2',
      borderRadius: 6,
      padding: theme.spacing(2, 1.5, 1),
      flex: 1,

      '& > header': {
        marginBottom: theme.spacing(1),

        '& > h3': {
          fontSize: '1.6rem',
        },

        '& > p': {
          fontSize: '1rem',
        },
      },

      '& ul': {
        listStyle: 'none',
        padding: 0,
        margin: 0,

        '& li': {
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          gap: '0.2rem',

          '& + li': {
            marginTop: '1rem',
          },

          '& > span:first-child': {
            flex: 1,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'space-between',

            fontSize: '1.2rem',

            height: '3.2rem',
            padding: '0.8rem',

            background: '#F0F0F0',
            borderRadius: 5,
          },

          '& .MuiFormControlLabel-root': {
            '& .MuiCheckbox-root': {
              marginLeft: 2,

              paddingTop: '0.4rem',
              paddingBottom: '0.4rem',

              '&:not(.Mui-disabled)': {
                color: '#646464',
                '&.Mui-checked, &.MuiCheckbox-indeterminate': {
                  color: theme.palette.primary.dark,
                },
              },
            },

            '& .MuiFormControlLabel-label': {
              display: 'inline-flex',
              flex: 1,

              fontWeight: 600,
              fontSize: '1.2rem',

              '& span:first-child': {
                flex: 1,
              },
              '& span:last-child': {
                fontWeight: 400,
              },
            },
          },
        },
      },
    },
    checkboxContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      border: '1px solid #D2D2D2',
      borderRadius: 6,
      padding: '0.5rem 1.5rem',
      margin: '0.5rem 0',
      '& .MuiTypography-body1': {
        fontSize: '1.2rem',
      },
      '& .MuiFormControlLabel-root .MuiCheckbox-root:not(.Mui-disabled)': {
        color: '#646464',
        '&.Mui-checked, &.MuiCheckbox-indeterminate': {
          color: theme.palette.primary.dark,
        },
      },
      '& > svg': {
        width: '1.6rem',
        color: '#646464',
      },
    },
    tooltip: {
      backgroundColor: '#505356',
      color: '#FFFFFF',
      maxWidth: '27rem',
      fontSize: '1.2rem',
      padding: '0.4rem 0.8rem',
      border: 'none',
      borderRadius: 5,
    },
    buttonContainer: {
      margin: '1rem 0',

      display: 'flex',
      gap: '1.2rem',

      '& button': {
        width: '100%',
        height: '3.6rem',
        margin: 0,

        gap: '1rem',
      },
    },
  }),
)
